export const TEST_OPTIONS = [
	{
		value: 'variant_site',
		label: 'Site variant',
	},
	{
		value: 'variant_quiz',
		label: 'Quiz variant',
	},
];
